// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"520":"e33f63ed","614":"382aa4ac"}[chunkId] + ".css";
};